module.exports = __webpack_public_path__ + "media/images/v2/logo-caf9ceffd4057eaef36f196b8906ae63.svg";